import { useState, useEffect } from "react";

const useUserBooks = () => {
    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const API_URL = process.env.REACT_APP_API;
    const prefix = 'api/usuario-editora';
    const posfix = '-usuario-editora';
    const [token, setToken] = useState(localStorage.getItem('token')); // Track token changes

    const fetchUserBooks = async () => {
        if (token) { // Only fetch data if token exists (user is logged in)
            try {
                const response = await fetch(API_URL + prefix + '/livros' + posfix, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + token,
                    },
                });
                if (!response.ok) {
                    throw new Error("Erro ao obter os livros do usuário.");
                }
                const data = await response.json();
                setBooks(data);
                setLoading(false);
            } catch (error) {
                setError(error.message);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchUserBooks();
    }, [token]);

    return { books, loading, error };
};

export default useUserBooks;
